// extracted by mini-css-extract-plugin
export var paginationContainer = "_95-0";